var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isAiChatbotReady
    ? _c("div", { class: _vm.customClass }, [
        _c(
          "section",
          {
            staticClass: "ai-chatbot-starter bg-white p-2",
            attrs: { "aria-label": _vm.regionLabel },
          },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("span", {
                staticClass:
                  "icon icon-ai-generative ai-chatbot-starter__icon me-1",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "h4 mb-0" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.dto.title) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("hr", {
              staticClass: "separator separator--gray4 my-1",
              attrs: { role: "presentation", "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass:
                  "list-unstyled d-flex flex-column flex-md-row flex-md-wrap align-items-start gap-1 mb-2",
              },
              _vm._l(
                _vm.dto.suggestedPrompts,
                function (suggestedPrompt, index) {
                  return _c(
                    "li",
                    { key: "ai-chatbot-starter-prompt-" + index },
                    [
                      _c(
                        "span",
                        { staticClass: "ob1-filterchip ob1-choicechip" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "ob1-filterchip-label",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.onChipClick(suggestedPrompt)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(suggestedPrompt) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }
              ),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center justify-content-md-start",
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-secondary d-inline-flex align-items-center",
                    attrs: {
                      type: "button",
                      "aria-label": _vm.newConversationAriaLabel,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onNewConversationClick()
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "icon icon-ai-generative me-1",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.dto.newConversationLabel) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }